/**
 * 新专区版本游戏模块通用mixins
 * 主要是 Detail.vue 和 MonthCardDetail.vue 里通用的一部分逻辑
 */

import { mapGetters, mapActions } from "vuex"
import * as url from "../../utils/url"
import * as enums from "../../store/enums"
import * as langs from "../../constants/langs"
import * as storeConfigApi from "@api/store-config"
import { getReservationRecommend } from "../../api/recommend"
import Raven from "raven-js"
import * as modals from "../../constants/modals"
import * as helper from "../../utils/helper"
import { loginStateUtil } from "../../utils/loginState"

export default {
  data() {
    return {
      reservationContent: []
    }
  },

  computed: {
    ...mapGetters(["userAgent", "loginState", "pf", "pfSource", "sandbox"])
  },

  methods: {
    ...mapActions(["setLoadingStart", "setLoadingEnd", "reportUserAction"]),
    /**
     * 获取预约游戏的配置
     */
    getReservationConfig() {
      let configUrl = langs.RESERVATION_CONFIG_URL_PATH
      let storeConfigEnv = url.getParam("store_config_env")
      if (storeConfigEnv && storeConfigEnv > 0) {
        configUrl = configUrl.replace("pay.qq.com", "sandbox.pay.qq.com")
      }
      return storeConfigApi
        .getConfigFromLocalStorage({
          configUrl: configUrl
        })
        .then(config => {
          if (config && config.itemList) {
            return Promise.resolve(config.itemList)
          } else {
            return Promise.reject()
          }
        })
        .catch(err => {
          Raven.captureException(new Error("getReservationConfig error"), {
            tags: { type: "getReservationConfig-error" },
            extra: {
              err,
              getters: this.$store.getters,
              rootState: this.$store.state
            }
          })
          return Promise.reject()
        })
    },
    /**
     * 获取预约的游戏
     * @param {Array} itemList - 所有业务商品的数组
     * @param {Array} operationConfig - 配置台预约游戏专区配置，为排序好的数组
     */
    getReservationGames(itemList, operationConfig) {
      let device = {
        system: this.userAgent.iOS ? "ios" : "android",
        channel: loginStateUtil(this.loginState).isQQSessionType ? "qq" : "wx"
      }
      let storeReservationGame = {}
      itemList.forEach(item => {
        if (item.busList && item.busList.length > 0) {
          item.busList.forEach(bus => {
            if (
              bus.categoryId &&
              bus.reservationConfig &&
              // 端游时status在对象bus对象最外层
              ((bus.categoryId == enums.BUSINESS_TYPE.PC_GAME && bus.status && bus.status == enums.PRODUCT_STATUS.APPOINTMENT) ||
                //  手游时status在bus[ios|android][qq|wx]里
                // 手游要根据用户的设备来推荐对应的游戏
                (bus.categoryId == enums.BUSINESS_TYPE.MOBILE_GAME &&
                  bus[device.system] &&
                  bus[device.system][device.channel] &&
                  bus[device.system][device.channel].status == enums.PRODUCT_STATUS.APPOINTMENT))
            ) {
              storeReservationGame[bus.busId] = bus
            }
          })
        }
      })
      this.sortBusinessByRecommend(storeReservationGame)
        .then(() => {
          this.sortBusinessByConfig(operationConfig)
        })
        .catch(err => {
          this.reservationContent = Object.values(storeReservationGame)
          this.sortBusinessByConfig(operationConfig)
          Raven.captureException(new Error("sort reservation list fail"), {
            tag: { type: "reservationSort-error" },
            extra: {
              err
            }
          })
        })
    },
    /**
     * 根据推荐处理对象
     * @param {Object} storeReservationGame - 从商店读取到的所有当前端支持的预约游戏
     */
    sortBusinessByRecommend(storeReservationGame) {
      return new Promise(resolve => {
        getReservationRecommend({
          loginState: helper.getLoginState(this.loginState),
          pf: `${this.pfSource}-${this.pf}-html5`,
          sandbox: this.sandbox,
          model: modals.GAME_RESERVATION.RECOMMEND_SORT
        })
          .then(res => {
            if (res && res.ret === 0 && res.recomm_info && storeReservationGame) {
              let recommendBusList = this.handleRecommendRes(res)
              let sortReservationContent = []
              recommendBusList.forEach(rBus => {
                if (storeReservationGame[rBus]) {
                  sortReservationContent.push(storeReservationGame[rBus])
                  storeReservationGame[rBus] = null
                }
              })
              // 将推荐中缺少的预约游戏添加到数组尾部
              Object.values(storeReservationGame).forEach(bus => {
                if (bus) {
                  sortReservationContent.push(bus)
                }
              })
              this.reservationContent = sortReservationContent
            }
            //  如果没有拿到正确的推荐数据，则将商店读取的预约游戏直接展示出来
            else {
              this.reservationContent = Object.values(storeReservationGame)
            }
            resolve()
          })
          .catch(err => {
            Raven.captureException(new Error("get recommend data fail"), {
              tag: { type: "getReservationRecommend-error" },
              extra: {
                err
              }
            })
          })
      })
    },
    /**
     * 处理推荐返回的数据
     * @param {Array} result - 推荐返回的响应
     */
    handleRecommendRes(result) {
      let recommend_info = result.recomm_info,
        arrayResult = []

      for (let i = 1, l = Object.keys(recommend_info).length; i <= l; i++) {
        let value = recommend_info[i]

        if (value != 0 && value !== undefined) {
          arrayResult.push(value)
        }
      }
      return arrayResult
    },
    /**
     * 根据配置处理对象
     * @param {Array} operationConfig - 配置台预约游戏专区配置，为排序好的数组
     */
    sortBusinessByConfig(operationConfig) {
      let count = 0
      let topArr = []
      operationConfig.forEach(item => {
        if (item.groupId_busId) {
          const [groupId, busId] = item.groupId_busId.split("_")
          for (let i = 0; i < this.reservationContent.length; i++) {
            if (this.reservationContent[i].groupId == groupId && this.reservationContent[i].busId == busId) {
              // 添加预约专区的配置zoneConfig
              this.reservationContent[i] = { ...this.reservationContent[i], ...item.zoneConfig }
              if (count < 3) {
                topArr.push(this.reservationContent[i])
                this.reservationContent.splice(i, 1)
                i--
                count++
              }
              break
            }
          }
        }
      })
      this.reservationContent = [...topArr, ...this.reservationContent]
    }
  }
}
